import { useCreditStore } from "../stores/creditStore";
import { CreditInformationResponse } from "../api/types";

type CreditType = "card" | "aave" | "euler";

interface UseCreditDataReturn {
  creditInfo: Record<CreditType, CreditInformationResponse | null>;
  isLoading: boolean;
  error: string | null;
}

export const useCreditData = (): UseCreditDataReturn => {
  const { creditInfo, isLoading, error } = useCreditStore();

  return {
    creditInfo,
    isLoading,
    error,
  };
};
